import React from "react";

import "../formContent.scss";
import { FormSection } from "./formSection/FormSection";
import {
	useGetFormRecoil,
	useGetSelectedSectionIndexRecoil,
	useSetSelectedSectionIndexRecoil,
} from "../../formDetail.service";
export const FormSections: React.FC = () => {
	const { form } = useGetFormRecoil();
	const { selectedSectionIndex } = useGetSelectedSectionIndexRecoil();
	const { setSelectedSectionIndex } = useSetSelectedSectionIndexRecoil();

	const handleSectionClick = (sectionIndex: number) => {
		setSelectedSectionIndex(sectionIndex);
	};

	const isComplete = false; // @TODO: get is complete from form?

	return (
		<div id="form-sections">
			{form?.sections.map((section, index) => (
				<FormSection
					key={index}
					index={index}
					section={section}
					isCompleted={isComplete}
					isSelected={index === selectedSectionIndex}
					onSectionClick={handleSectionClick}
				/>
			))}
		</div>
	);
};
